/** After any logistics RFQ (generic / business relocation / exhibition) succeeds, the browse page shows View RFQ on every card. */
export const LGRQ_ANY_SUBMITTED_SESSION_KEY = 'lgrq-any-logistics-rfq-submitted';

/** Persist in both storages: session-only breaks if submit and list run in different tabs; localStorage survives refresh. */
export function setLogisticsRfqSubmittedSessionFlag() {
  try {
    sessionStorage.setItem(LGRQ_ANY_SUBMITTED_SESSION_KEY, '1');
  } catch {
    /* ignore */
  }
  try {
    localStorage.setItem(LGRQ_ANY_SUBMITTED_SESSION_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function readLogisticsRfqSubmittedFlag() {
  try {
    if (sessionStorage.getItem(LGRQ_ANY_SUBMITTED_SESSION_KEY) === '1') return true;
  } catch {
    /* ignore */
  }
  try {
    if (localStorage.getItem(LGRQ_ANY_SUBMITTED_SESSION_KEY) === '1') return true;
  } catch {
    /* ignore */
  }
  return false;
}
